export const PHONE_REGEX = /^([\+][0-9]{1,3})?([ \.\-])?([\(]{1}[0-9]{1,6}[\)])?([0-9 \.\-/]{3,20})((x|ext|extension)[ ]?[0-9]{1,4})?$/;  /* eslint-disable-line */
